import { Component, OnInit } from "@angular/core"
import { FooterService } from "../../services/footer.service"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"
import Utils from "../../utils/utils"
import { ModalService } from "../modal/modal.service"
import { InformationModalComponent } from "../modals/information-modal/information-modal.component"
import { FeedbackModalComponent } from "./feedback-modal/feedback-modal.component"
import { AuthModalComponent } from "../modals/auth-modal/auth-modal.component"
import { ActivatedRoute, Router } from "@angular/router"
import { ResourceService } from "../../services/resource.service"
import { STATIC_IMAGES } from "../../models/constants"
import { AddOnViewService } from "../../services/add-on-view.service"
import { take } from "rxjs/operators"
import { asyncScheduler } from "rxjs"

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent extends EduComponent implements OnInit {
    feedbackFormHtml = null
    gtmPrefix: string = "gtm-footer-"
    pbsLogoWhite
    currentYear
    isAddonView: boolean
    isEmailValid: boolean = false
    isStudentExperience: boolean = false
    email: any = ""

    constructor(
        private footerService: FooterService,
        private modalService: ModalService,
        public userService: UserService,
        private resourceService: ResourceService,
        public addOnService: AddOnViewService,
        public router: Router,
        public route: ActivatedRoute
    ) {
        super()
        this.pbsLogoWhite = STATIC_IMAGES.pbs_logo_white
    }

    public ngOnInit() {
        this.currentYear = Utils.getCurrentYear()
        this.isAddonView = this.addOnService.isAddonView
        this.isStudentExperience = Utils.hasStudentExperience()
        this.handleScrollToAnchorTag()
    }

    public handleScrollToAnchorTag(): void {
        this.route.fragment.pipe(take(2)).subscribe((fragment: string) => {
            if (fragment === "email-eloqua-newsletter")
                asyncScheduler.schedule(() => {
                    this.jumpTo()
                }, 1500)
        })
    }

    public teacherLogin() {
        if (window.location.pathname === "/student/") {
            this.router.navigate(["/"])
        } else {
            this.resourceService.switchResourceView()
        }
        this.modalService.open(AuthModalComponent)
    }

    public changeUserExperience(studentState: boolean, target?: string) {
        this.userService.switchUserExperience(studentState, target)
    }
    public openFeedbackForm(event) {
        event.preventDefault()
        this.modalService.open(FeedbackModalComponent, { size: "lg" })
    }

    validateEmail() {
        this.email = (document.getElementById("email-eloqua-newsletter") as HTMLInputElement).value
        this.isEmailValid = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.email)
    }

    public subscribe() {
        const settings = (window as any).PBSLM.eloqua.footer
        const subscribeBtn = document.getElementById("eloqua-newsletter-go")
        this.addSub(
            this.footerService
                .subscribeToNewsletter(
                    settings.url,
                    settings.elqFormName,
                    settings.elqSiteId,
                    this.email
                )
                .subscribe(
                    (response) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        this.modalService.open(InformationModalComponent, {
                            data: {
                                message: "You have been subscribed to the newsletter!",
                                shouldDisplayHeaderCloseButton: true,
                                shouldDisplayFooterCloseButton: true,
                            },
                        })
                    },
                    (error) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        this.modalService.open(InformationModalComponent, {
                            data: {
                                message: "Something went wrong. Please try again later.",
                                shouldDisplayHeaderCloseButton: true,
                                shouldDisplayFooterCloseButton: true,
                            },
                        })
                    }
                )
        )
    }

    public jumpTo(): void {
        const area = document.getElementById("email-eloqua-newsletter")

        if (area) {
            area.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            })
            area.focus()
        }
        this.router.onSameUrlNavigation = "ignore"
        this.router.navigate([], {
            fragment: `email-eloqua-newsletter`,
            relativeTo: this.route,
        })
    }
}
